import { Modal } from "@shopify/polaris";
import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import { OPEN_MODAL_SWITCHING_PLAN } from "../../../constants/modalTypes.js";
import { useAppMutation } from "../../../hooks/index.js";
import { closeModal } from "../../../store/features/modal.js";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux.js";

const SwitchingPlanModal = () => {
  const dispatch = useAppDispatch();
  const modal = useAppSelector(({ modal }) => modal);

  const handleRedirect = useCallback((url) => {
    window.open(url, "_top");
  }, []);

  const handleClose = useCallback(() => {
    dispatch(closeModal());
  }, []);

  const { mutate, isLoading } = useAppMutation({
    url: "/api/app-subscription/create",
    reactMutationOptions: {
      onSuccess: ({ confirmUrl }) => {
        handleRedirect(confirmUrl);
      }
    }
  });

  const handleContinue = useCallback(() => {
    mutate({
      planId: modal.modalData.planId,
      subscriptionInterval: modal.modalData.subscriptionInterval,
      host: modal.modalData.host
    });
  }, [mutate, modal]);


  return (
    <Modal
      open={modal.isOpen && modal.modalType === OPEN_MODAL_SWITCHING_PLAN}
      onClose={handleClose}
      title="By switching plan, you will lose your currently running trial. Are you sure you’d like to switch plan?"
      primaryAction={{
        content: "Continue",
        loading: isLoading,
        onAction: handleContinue
      }}
      secondaryActions={[{
        content: "Cancel",
        onAction: handleClose
      }]}
    />
  );
};

export default SwitchingPlanModal;